import React, { useState, useEffect } from "react";
import ModalWrapper from "../../../../components/learning-development/common/ModalWrapper";
import api from "../../../../Axios.js";
import { toast } from "react-toastify";

const CertificateUploadModal = ({
  isOpen,
  onClose,
  certificateUrl,
  fetchRequests,
  requestId,
}) => {
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  // Set initial preview when modal opens
  useEffect(() => {
    if (certificateUrl) {
      setPreview(certificateUrl);
    }
  }, [certificateUrl]);

  const handleFileChange = (e) => {
    setFile(null);
    const selectedFile = e.target.files[0];

    if (!selectedFile) return;

    const allowedTypes = ["image/png", "image/jpeg"];
    const maxSize = 5 * 1024 * 1024; // 5MB

    // Reset error
    setError("");

    // Type validation
    if (!allowedTypes.includes(selectedFile.type)) {
      setError("Only PNG, JPG, and JPEG files are allowed.");
      setPreview(null);
      return;
    }

    // Size validation
    if (selectedFile.size > maxSize) {
      setError("File size must be less than 5MB.");
      setPreview(null);
      return;
    }
    setFile(selectedFile);

    if (selectedFile) {
      const reader = new FileReader();
      reader.onload = (ev) => setPreview(ev.target.result);
      reader.readAsDataURL(selectedFile);
    }
  };

  const handleUpload = async () => {
    if (!file) return;

    setLoading(true);

    try {
      const formData = new FormData();
      formData.append("file", file);

      const res = await api.post(
        `/lnd/user/elr/upload-certificate?request_id=${requestId}`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      onClose();
      fetchRequests();
      toast.success("Certficate uploaded successfully");

    } catch (error) {
      console.error("Upload error:", error);
      toast.success(error.message || "Upload failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    isOpen && (
      <ModalWrapper onClose={onClose}>
        <h5 className="fw-bold mb-3">Upload Certificate</h5>

        {/* File Input */}
        <input
          type="file"
          accept=".png, .jpg, .jpeg"
          className="form-control"
          onChange={handleFileChange}
        />

        {/* File Format and Size Guidelines */}
        <small className="text-muted d-block mt-2">
          Allowed formats: PNG, JPG, JPEG | Max file size: 5MB
        </small>

        {error && (
          <small className="text-danger d-block mt-1">
            {error}
          </small>
        )}

        {/* Preview */}
        {preview && (
          <div className="mt-3 text-center">
            {preview.includes("pdf") ? (
              <iframe
                src={preview}
                title="Certificate Preview"
                width="100%"
                height="300px"
              />
            ) : (
              <img
                src={preview}
                alt="Certificate Preview"
                style={{ maxWidth: "100%", maxHeight: 300 }}
              />
            )}
          </div>
        )}

        {/* Buttons */}
        <div className="d-flex flex-wrap gap-2 mt-3">
          <button
            className="btn btn-success"
            onClick={handleUpload}
            disabled={!file || loading}
          >
            {loading ? "Uploading..." : "Upload"}
          </button>

          <button
            className="btn btn-outline-secondary"
            onClick={onClose}
            disabled={loading}
          >
            Close
          </button>
        </div>
      </ModalWrapper>
    )
  );
};

export default CertificateUploadModal;